// Porta da rota /ia: quem não tem acesso volta para o dashboard em vez de abrir
// o chat e receber 403 da API. O bloqueio de verdade é no backend — este
// componente só evita mostrar um erro para quem só errou o link.

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-hook';
import { podeAcessarIA } from './ia-acesso';

export function IARoute({ children }: { children: ReactNode }) {
  // Enquanto a sessão não resolveu, o squad ainda é desconhecido — redirecionar
  // aqui expulsaria quem tem acesso.
  const { user, isAdmin, loading } = useAuth();

  if (loading) return null;
  if (!podeAcessarIA(user?.squadNome, isAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
